import { render, staticRenderFns } from "./CoursePackage.vue?vue&type=template&id=b2289f84&"
import script from "./CoursePackage.vue?vue&type=script&lang=js&"
export * from "./CoursePackage.vue?vue&type=script&lang=js&"
import style0 from "./CoursePackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports